export default __webpack_public_path__ + "locales/sk/PeopleTranslations.json?hash=d12b2fe576f7cb34dbab43b473c53ba4";